import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Group } from './group.model';

export interface GroupState extends EntityState<Group> {
  active: Group | string;
}
const arrayToMap = <T extends { id: string }>(items: T[]) =>
  items.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {});

@StoreConfig({
  name: 'group',
})
@Injectable()
export class GroupStore extends EntityStore<GroupState> {
  constructor() {
    super();
    super.akitaPreUpdateEntity = this.akitaPreUpdateEntity.bind(this);
  }

  akitaPreAddEntity = (group: Group) => {
    return {
      ...group,
      usersMap: arrayToMap(group.users),
    };
  };

  akitaPreUpdateEntity = (oldGroup: Group, newGroup: Group): Group => {
    return {
      ...newGroup,
      usersMap: arrayToMap(newGroup.users),
      lastMessageReceivedAt:
        newGroup.lastMessageReceivedAt || oldGroup.lastMessageReceivedAt,
    };
  };
}
